import React from 'react';
import {useStepStore} from "react-step-machine";

export function ProgressBar() {
    const {totalSteps, activeStep} = useStepStore();
    const activeWidth = activeStep / totalSteps * 100
    return (
        <div className='wizardProgressContainer' >
            <div className='wizardProgressGray'>
                <div className='wizardProgressActive' style={{width: activeWidth + '%' }}>
                    <div>{activeWidth} %</div>
                </div>
            </div>
        </div>
    )
}